type Props = {
  children: string
  className?: string
  reverse?: boolean
  color?: string
}

const PageTitle = ({ children, className, reverse, color }: Props) => {
  return (
    <h2
      className={`${
        reverse ? '' : 'ml-4'
      } text-xl leading-normal md:text-2xl lg:text-3xl ${
        color === 'white' ? 'text-white' : ''
      } ${className}`}
    >
      {children}
    </h2>
  )
}

export default PageTitle
